const BASE = "https://static.prod-images.emergentagent.com/jobs/b578c306-d3b7-4c9b-a231-380d1a9c3f99/images/";

export const IMG = {
  logo: "/jpstore-logo.png",
  rdCoin: `${BASE}186a6d464ad1082b57b2bb4605c9f03af492d7bf9a72b48f390157862628e5d0.jpeg`,
  higgsTile: `${BASE}c91ed6b4f13842009eb40ca3f58bdce784fefbb9fb6a576c35e36f58319e603f.jpeg`,
  higgsCat: `${BASE}c1ddcfde55b0ba336dc78b59a43c06b86588bf9e15596091b8c3f96bcf5164b3.jpeg`,
  rdChar: `${BASE}0e2803d5fda5f9d1b7b5bbf3b06cce0e660b5e09ea14a9d69cbc964527ec0308.jpeg`,
  higgsChar: `${BASE}d4733a1ea88d8050e5c93b2dff7b60d45aa71026d217f5fc356e63a79c2d1c20.jpeg`,
  bannerHiggs: `${BASE}e39f5eb9f795d2a28564371f79aec9e0ff015b9dd1b41c4a1ccbbd0f957ee339.jpeg`,
  bannerRoyal: `${BASE}9700653686ac5d4f733c45e5c7f89263917db8a07558070856a78ccff0f5fb2f.jpeg`,
};

export const PRODUCT_SLUGS = {
  royaldream: "royal_dream",
  higgsdomino: "higgs_domino",
};

export const PRODUCT_PATH = {
  royal_dream: "/topup/royaldream",
  higgs_domino: "/topup/higgsdomino",
};

export const LEGACY_SLUGS = {
  "kaisar-rd": "/topup/royaldream",
  "kaisar-higgs": "/topup/higgsdomino",
  "jpstore-rd": "/topup/royaldream",
  "jpstore-higgs": "/topup/higgsdomino",
};
